export type TCdsTabItem = 'string' | Record<string, any>;

export function parseItems(items: readonly TCdsTabItem[] | undefined) {
  if (!items) return [];

  return items.map((item) => {
    if (typeof item === 'string') return { title: item, value: item };

    return item;
  });
}
